<template>
  <div class="product-link-details">

    <section class="image-container">
      <img v-bind:src="modalProps.productLink.imageUrl" onerror="this.style.opacity='0'">
    </section>

    <section class="main-content">
      <h3>{{productLink.name}}</h3>

      <div class="link">
        At
        <a v-if="productLink.isCustom" v-on:click="onLinkClick" target="blank" class="product-link">{{productLink.retailerName}}</a>
        <a v-if="!productLink.isCustom" v-on:click="onLinkClick" target="blank" class="product-link">{{productLink.networkRetailer.name}}</a>
      </div>

      <div class="price">
        <span v-if="productLink.price">{{ numberToCurrency(productLink.price) }}</span>
      </div>
      <div class="commission">
        Estimated Commission:
        <b v-if="productLink.isCustom && !productLink.proCommission">{{ productLink.proCommissionRate ? productLink.proCommissionRate * 100 + '%' : 'N/A' }}</b>
        <b v-else>{{ numberToCurrency(productLink.proCommission) }}</b>
      </div>

      <div class="buttons">
        <span class="display-button" v-on:click="onCopyShareLinkClick()">Copy Link</span>
        <span v-if="showAddToScript" class="display-button" v-on:click="addToScriptClick(productLink)">
          Add to Script
        </span>
      </div>

      <!-- Not quite working - 3/21/21 -->
      <!-- <div class="social">
        <span v-if="showFacebook(modalProps.productLink)" class="facebook">
          <a v-if="!userProductLinkUrl" v-on:click="createProductLinkForUser(facebookShareCallback)">
            <img src="@/assets/images/icons/facebook-black.svg">
          </a>
          <a v-else v-bind:href="facebookShareUrl" target="_blank" alt="Share on Facebook">
            <img src="@/assets/images/icons/facebook-black.svg">
          </a>
        </span>
        <span class="twitter">
          <a v-if="!userProductLinkUrl" v-on:click="createProductLinkForUser(twitterShareCallback)">
            <img src="@/assets/images/icons/twitter-black.svg">
          </a>
          <a v-else v-bind:href="twitterShareUrl" target="_blank" alt="Share on Twitter">
            <img src="@/assets/images/icons/twitter-black.svg">
          </a>
        </span>
        <span class="pinterest">
          <a v-if="!userProductLinkUrl" v-on:click="createProductLinkForUser(pinterestShareCallback)">
            <img src="@/assets/images/icons/pinterest-black.svg">
          </a>
          <a v-else v-bind:href="pinterestShareUrl" target="_blank" alt="Share on Pinterest">
            <img src="@/assets/images/icons/pinterest-black.svg">
          </a>
        </span>
      </div> -->

      <div class="colors-sizes">
        <span v-if="productLink.colors" class="colors"><b>Available colors:</b> {{productLink.colors}}</span>
        <span v-if="productLink.sizes" class="sizes"><b>Available sizes:</b> {{productLink.sizes}}</span>
      </div>

      <div class="description">
        <span v-if="productLink.description">{{productLink.description}}</span>
        <span v-else>No description available.</span>
      </div>
    </section>

  </div>
</template>

<script>

import EventBus from '@/components/utilities/EventBus'
import stringHelper from '@/helpers/stringHelper'
import { mapGetters } from 'vuex'

export default {
  name: 'ProductLinkDetails',
  props: {
    modalProps: {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    return {
      productLink:        this.modalProps.productLink,
      addToScriptClick:   this.modalProps.addToScriptClick,
      showAddToScript:    this.modalProps.showAddToScript,
      userProductLinkUrl: null
    }
  },
  updated () {
    // Need to update every time modal is opened
    this.productLink      = this.modalProps.productLink
    this.addToScriptClick = this.modalProps.addToScriptClick
  },
  computed: {
    ...mapGetters({ currentUser: 'currentUser' }),
    facebookShareUrl () {
      return 'https://www.facebook.com/sharer/sharer.php?u=' + this.userProductLinkUrl
    },
    twitterShareUrl () {
      let text = encodeURI('Check out this product I found using Beauty Scripts!')
      return 'https://twitter.com/intent/tweet?url=' + encodeURI(this.userProductLinkUrl) + '&text=' + text
    },
    pinterestShareUrl () {
      let text = encodeURI('Check out this product I found using Beauty Scripts!')
      return 'http://pinterest.com/pin/create/button/?url=' + encodeURI(this.userProductLinkUrl) + '&media=' + encodeURI(this.modalProps.productLink.imageUrl) + '&description=' + text + '&image_url=' + encodeURI(this.modalProps.productLink.imageUrl)
    }
  },
  methods: {
    onCopyShareLinkClick () {
      if (!this.userProductLinkUrl) {
        this.createProductLinkForUser(this.copyShareLink)
      } else {
        this.copyShareLink()
      }
    },
    copyShareLink (productLink) {
      if (productLink) this.userProductLinkUrl = productLink.url

      this.$copyText(this.userProductLinkUrl)          // This uses VueClipboard
      EventBus.$emit('drop', {
        message: 'Link copied to clipboard!',
        statusCode: 1
      })
    },
    onLinkClick () {
      if (this.userProductLinkUrl) {
        this.onProductLinkCreated()
      } else {
        this.createProductLinkForUser(this.onProductLinkCreated)
      }
    },
    createProductLinkForUser (callback) {
      this.axios.post('users/' + this.currentUser.id + '/product_links', { product_link: stringHelper.unCamelizeObject(this.modalProps.productLink) })
        .then((response) => { callback(stringHelper.camelizeObject(response.data.product_link)) })
    },
    onProductLinkCreated (productLink) {
      if (productLink) this.userProductLinkUrl = productLink.url
      window.open(this.userProductLinkUrl, '_blank')
    },
    showFacebook (productLink) {
      return productLink.network.name !== 'rakuten'
    },
    facebookShareCallback (productLink) {
      if (productLink) this.userProductLinkUrl = productLink.url
      window.open(this.facebookShareUrl, '_blank')
    },
    twitterShareCallback (productLink) {
      if (productLink) this.userProductLinkUrl = productLink.url
      window.open(this.twitterShareUrl, '_blank')
    },
    pinterestShareCallback (productLink) {
      if (productLink) this.userProductLinkUrl = productLink.url
      window.open(this.pinterestShareUrl, '_blank')
    },
    // EXTERNAL METHOD
    modalCloseCallback () {
      this.userProductLinkUrl = null
    }
  }
}
</script>

<style lang="scss" scoped>

.product-link-details {

  display:                        flex;
  align-items:                    center;

  .image-container {
    width:                        30%;

    img {
      width:                      auto;
      max-height:                 20em;
      max-width:                  95%;
      margin:                     0 auto;
      display:                    block;
    }
  }

  .main-content {
    width:                        65%;
    margin-left:                  5%;
    max-height:                   440px;
    overflow:                     scroll;

    > h3 {
      margin-bottom:              0em;
    }

    .price {
      font-size:                  1.5em;
      font-weight:                bold;
      margin-top:                 0.75em;
    }

    .buttons {
      margin:                     0.75em 0;

      > .display-button {
        display:                  inline-block;
        cursor:                   pointer;
        border-radius:            2em;
        padding:                  0.5em 0.75em;
        border:                   0;
        background-color:         #ccc;
        text-align:               center;
        margin-right:             0.25em;

        &:hover {
          background-color:       black;
          color:                  white;
        }
      }
    }

    .link {
      margin-top:                 0.25em;

      a {
        color:                    black;
        text-decoration:          underline;
        cursor:                   pointer;
      }
    }

    .social {
      margin:                     1em 0;

      a {

        margin-right:             0.75em;

        img {
          height:                 1.75em;

          &:hover {
            opacity:              0.5;
          }
        }
      }
    }

    .colors-sizes {
      > span {
        display:                  block;
      }
    }

    .description {
      margin-top:                 1em;
      font-size:                  0.9em;
      color:                      #6f6f6f;
    }
  }
}

/* Landscape phone to portrait tablet */
@media (max-width: 767px) {
  .product-link-details {

    flex-wrap:                    wrap;

    .image-container {
      width:                      100%;
      margin-bottom:              1em;

      img {
        max-height:               15em;
      }
    }

    .main-content {
      width:                      100%;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/product-link/ProductLinkDetails.vue